import * as signalR from "@microsoft/signalr";
// import i18n from "@/i18n/i18n.js";
import { Customer } from "@/api/customer";
import { Basic } from "@/api/settingMetas";
import axios from "axios";
import router from "@/router";
import { MessageBox } from "element-ui";

const notification = document.getElementById("notification");
const REFUSES = "Declined the invitation";
const state = {
  AC_CustomerData: "",
  isPreventLeave: true,
  connection: null,
  hubUrl: process.env.VUE_APP_BASEURL + "/clientChat",
  clientChatRoom: null,
  wattingStatus: null,
  isChatFinish: false,
  isCustomerLeave: false,
  isAgentTyping: false,
  agentState: 1,
  isAcceptVideoCall: null,
  offlineMessages: [],
  isRemoteControl: false, // (ACI)Survey由遠程控制   true = ATR005 = 不顯示問卷
  replyMessage: null,
};

const actions = {
  // auth
  create({ rootState, commit }, payload) {
    const api =
      payload === "FromPostRepair"
        ? Customer.CreateFromPostRepair
        : Customer.create;
    return new Promise((resolve, reject) => {
      api(rootState.global.customerSurvey)
        .then((res) => {
          // console.log('create res', res);
          // 200
          localStorage.removeItem("asus_chat_query");
          commit("setCustomer", res.data);
          if (res.data.isSuccess) {
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + res.data.token;
            resolve(res);
          } else {
            reject({ errCode: 1, otherChatting: res.data.otherChatting });
          }
        })
        .catch((err) => {
          // console.log("catch", err);
          // errCode:
          // 0. other 400 error
          // 1. Other Chats are not Finished
          // 2. workoff  / Country Skill NoService.
          // 3. isBBY (ACI only)
          // 4. NonWarranty // 是否保固內
          // 5. ProductSN is not valid // AP-3947 (SN必填，判斷SN是否有效)
          if (err.data == "ProductSN is not valid") {
            reject({ errCode: 5 });
          } else if (err.data == "NonWarranty") {
            reject({ errCode: 4 });
          } else if (err.data == "isBBY") {
            reject({ errCode: 3 });
          } else if (err.data == "Country Skill NoService.") {
            reject({ errCode: 2 });
          } else if (err.data == "Country Working Day Off") {
            reject({ errCode: 2 });
          } else {
            reject({ errCode: 0 });
          }
          localStorage.removeItem("AC_CustomerData");
        });
    });
  },
  initConnection({ commit, dispatch, getters }) {
    // console.log("1. 初始化 new signalR.HubConnectionBuilder()");
    commit("setConnecttion", getters.token);
    commit("toggleChatFinish", false);
    dispatch("startConnection");
  },
  startConnection({ state, dispatch, getters }, payload = false) {
    return new Promise((resolve, reject) => {
      let skipStartToCommunication = payload;
      // console.log("2. start connection");
      state.connection
        .start()
        .then(function() {
          dispatch("onReady");
          if (!skipStartToCommunication) {
            dispatch("startToCommunication", {
              customerId: getters.customerId,
              token: getters.token,
            });
          }
          resolve("start!");
        })
        .catch((error) => {
          reject("error");
          console.log("(連線錯誤)Error establishing the connection: ", error);
        });
    });
  },
  // 自定義 on 事件
  onReady({ state, dispatch, commit, getters }) {
    state.connection.on("onError", (message) => {
      console.log("Connection Error", message);
      if (message == "Customer not in room." || message == "not in room.") {
        // router.replace("/error");
        router.replace("/chatClose");
      }

      let path = router.currentRoute.path;
      if (path == "/chatroom/webrtc") {
        alert("Connection Error: " + message);
        router.replace("/chatroom/webrtcEnd");
      }
    });
    state.connection.on("newMessage", async (data) => {
      // console.log("on newMessage", data);
      let { type, isNewTransferAgentIntro } = data;
      // AP-6866
      if (isNewTransferAgentIntro) {
        const country = data.agentCountry;
        try {
          const res = await Basic.get(country);
          // 透過 Agent 新 country 重新 GetBasicSetting 更新聊天室設定
          commit("updateCustomerData", res.data);
          // 重置 survey 條件 (秒數)
          commit("global/setTotalTime", "off", { root: true });
        } catch (error) {
          console.log("error", error);
        }
      }
      if (type == "Wait") {
        // status.2 = Wait
        commit("tooglePreventLeave", false);
        // 關閉 preventLeave 讓使用者直接離開 connectting 畫面不跳出警告
        commit("setWattingStatus", data);
        // 強制將使用者頁面切換至排隊頁
        if (router.currentRoute.path !== "/waitting") {
          router.replace("/waitting");
        }
      } else if (type == "NoService") {
        // status.3 = No Service
        // console.log("NoService", data);
        commit("tooglePreventLeave", false);
        router.replace("/unService");
        dispatch("leaveRoom");
      } else if (type == "All") {
        // 接收斷線中錯過的訊息
        commit("updateAllMessage", data.messages);
      } else if (type == "AgentIsTyping") {
        let timer = null;
        if (timer) {
          clearTimeout(timer);
        } else {
          commit("setAgentIsTyping", true);
          timer = setTimeout(function() {
            commit("setAgentIsTyping", false);
          }, 5000);
        }
      } else if (type == "QRCode") {
        MessageBox.confirm(
          "Please scan this QRCode with your mobile phone.Please read the following instructions carefully before making a video call:In order to protect the rights and interests of users, the video recording process will be recorded/green tone. If you do not agree, please click 'Cancel' to return to the text service page Use of a metered internet connection, including mobile data and international roaming, may incur additional charges when data usage is exceeded.In order to protect the rights and interests of others, the maximum duration of the digital call is 10 minutes. When the time is up, the video will be interrupted and the customer service page will be returned to.",
          {
            confirmButtonText: "Agree",
            cancelButtonText: "Cancel",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            center: true,
            showClose: false,
          }
        )
          .then(() => {
            commit("updateMessage", data);
          })
          .catch(() => {
            dispatch("answerCall", {
              clientChatRoomId: state.clientChatRoom.id,
              customerId: state.AC_CustomerData.id,
              token: getters.token,
              MessageId: data.id,
              IsAcceptCall: false,
            });
          });
      } else {
        let path = router.currentRoute.path;
        if (
          path !== `/chatroom/${getters.roomId}` &&
          path !== "/chatroom/webrtc" &&
          path !== "/chatroom/webrtcEnd"
        ) {
          /* 畫面在webrtc與webrtcEnd時，有可能聊天未結束
          不需將此分頁（手機掃描 QRCode 進來的頁面）導回聊天室 */
          commit("tooglePreventLeave", false);
          router.replace(`/chatroom/${getters.roomId}`);
        }

        if (type !== "System") {
          let isMe = state.AC_CustomerData.userName == data.user.username;
          if (!isMe) {
            notification.pause();
            notification.currentTime = 0;
            notification.play();
          }
        }

        if (type == "Text") {
          commit("removeOfflineMessage", data.uuid);
        }

        commit("updateMessage", data);
        commit("global/setIdleTime", "off", { root: true }); // 閒置重置
      }
    });
    state.connection.on("unsendMessage", (data) => {
      commit("removeMessage", data);
    });
    state.connection.on("JoinChatRoom", (data) => {
      commit("setClientChatRoom", data.value.clientChatRoom);
    });
    state.connection.on("CreateChatRoom", (data) => {
      commit("setClientChatRoom", data.value.clientChatRoom);
    });
    state.connection.on("ReceiveHeartBeat", (data) => {
      dispatch("replyHeartBeat", data);
    });
    state.connection.on("AgentChatFinish", (data) => {
      // ACD強制專員斷線
      commit("toggleAgentState", 1); // 關閉網路斷線提示(agentOffline)
      dispatch("leaveRoom", false); // false = 專員發起離開
    });
    state.connection.on("ChatFinish", (data) => {
      // 專員發起離開
      let { msg, terminateReasonCode } = data;
      commit(
        "setRemoteControl",
        terminateReasonCode == "ATR005" ? true : false
      );
      if (msg === "AgentLeaveRoom") {
        dispatch("leaveRoom", false); // false = 專員發起離開
      }
    });
    state.connection.on("agentOffline", () => {
      commit("toggleAgentState", 0);
    });
    state.connection.on("agentOnline", () => {
      commit("toggleAgentState", 1);
    });
    state.connection.on("LeaveRoom", (res) => {
      if (res.note == "leaveCustomer") {
        // leaveCustomer = 前端定義 = 被踢出的情境
        router.replace("/chatEnd");
      }
    });
    // (暫無動作)
    state.connection.on("RemoveLeaveRoomUser", () => {});
    state.connection.on("RemoveChatRoom", () => {});
    state.connection.on("newCustomerTempMessage", () => {});
    state.connection.on("ReceiveCustomerHeartBeat", () => {});
    // 原生事件
    state.connection.onreconnecting(() => {});
    state.connection.onreconnected(() => {
      dispatch("GetClientChatAllMessage");
    });
    state.connection.onclose(() => {});
    // webrtc
    // (暫無動作)
    state.connection.on("inComingCall", () => {});
    state.connection.on("callResult", () => {});
    state.connection.on("receiveSignal", (data) => {
      let signal = JSON.parse(data.signal);
      dispatch("webrtc/receiveSignal", signal, { root: true });
    });
    state.connection.on("callEnded", (data) => {
      let { hangUpBy } = data;
      if (hangUpBy !== "Customer") {
        // 若為 Customer 自己發起, Customer 也須關閉 webrtc
        // 若為 Agent 發起, Customer 也須關閉 webrtc
        dispatch("webrtc/hangup", null, { root: true });
      }
    });
  },
  // 自定義 invoke 事件
  startToCommunication({ state }, payload) {
    // console.log("4. 建立Chat Room startToCommunication", payload);
    state.connection.invoke("StartToCommunication", payload);
  },
  sendMessageToAgent({ rootState, state, commit, getters }, payload) {
    let status = rootState.global.internet_status;
    let uuid = new Date().getTime().toString();
    let params = {
      replyId: state.replyMessage ? state.replyMessage.id : null,
      uuid: uuid,
      clientChatRoomId: getters.roomId,
      customerId: getters.customerId,
      token: getters.token,
      content: payload.content,
      type: payload.type,
    };

    if (payload.type !== "CustomerStatus") {
      setTimeout(() => {
        commit("setOfflineMessage", params); // 暫存區
      }, 1000);
    }

    if (status !== "offline" && state.connection !== null) {
      commit("setReplyMessage", null); // clean replyMessage
      state.connection.invoke("SendMessageToAgent", params);
    }
  },
  sendTempMessageToAgent({ rootState, state, getters }, payload) {
    let status = rootState.global.internet_status;
    let params = {
      clientChatRoomId: getters.roomId,
      customerId: getters.customerId,
      token: getters.token,
      content: payload.content,
      type: payload.type,
    };
    if (state.connection !== null && status !== "offline") {
      state.connection
        .invoke("SendTempMessageToAgent", params)
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  sendOfflineMessage({ state, commit, dispatch }, payload) {
    // 離線未送出的訊息
    let target = state.offlineMessages.find((m) => m.uuid == payload);
    dispatch("sendMessageToAgent", target);
    commit("removeOfflineMessage", payload);
  },
  // 把舊(其他)聊天室關閉
  leaveCustomer(context, otherChatting) {
    otherChatting.forEach((user) => {
      state.connection.invoke("CustomerLeaveRoom", {
        ...user,
        note: "leaveCustomer",
      });
    });
  },
  // 閒置太久離開
  idleLeave({ dispatch, state, commit, getters }) {
    commit("tooglePreventLeave", false);
    let params = {
      customerId: getters.customerId,
      clientChatRoomId: getters.roomId,
      token: getters.token,
      note: "",
      ERoomTerminateReason: "CustomerTimeout",
    };
    state.connection.invoke("CustomerLeaveRoom", params);
    commit("cleanConnection");
  },
  leaveRoom({ state, commit, getters }, payload = false) {
    commit("tooglePreventLeave", false);
    if (payload !== null) {
      // null = 客戶主動離開"排隊" or 主動離開並且不進入問卷
      if (payload) {
        commit("toggleCustomerLeave", true);
        //  payload = true = 由客戶主動發起離開，打開調查2
      } else {
        commit("toggleChatFinish", true);
        // payload = false = 由專員發起結束對話，打開調查1
      }
    }
    if (state.connection !== null) {
      state.connection.invoke("CustomerLeaveRoom", {
        customerId: getters.customerId,
        ClientChatRoomId: getters.roomId,
        token: getters.token,
        note: "",
      });
    }
  },
  customerHeartBeat({ rootState, state, dispatch }) {
    // console.log("send heartBeat.");
    let status = rootState.global.internet_status;
    if (status !== "offline" && state.connection !== null) {
      var data = {
        clientChatRoomId: state.clientChatRoom.id,
        customerId: state.AC_CustomerData.id,
        token: state.AC_CustomerData.token,
      };
      dispatch("global/heartBeat", "", { root: true });
      // console.log("CustomerHeartBeat!");
      state.connection.invoke("CustomerHeartBeat", data);
    }
  },
  GetClientChatAllMessage({ state }) {
    // 重新連線後取得所有對話紀錄
    // 注意 clientChatRoomId 來源：
    // 1. 從 qrcode link (webrtc)進來的話 clientChatRoomId 來自 AC_CustomerData
    // 2. 斷線重連進來的話，從clientChatRoom 取得
    if (state.connection !== null) {
      let customer = state.AC_CustomerData;
      let clientChatRoomId =
        state.clientChatRoom.id || customer.clientChatRoomId;

      let params = {
        clientChatRoomId: clientChatRoomId,
        customerId: customer.id,
        token: customer.token,
      };

      state.connection.invoke("GetClientChatAllMessage", params);
    }
  },
  customerJoinRoom({ state }, payload) {
    state.connection.invoke("CustomerJoinRoom", payload);
  },

  // webrtc
  answerCall({ dispatch, commit, state, getters }, payload) {
    let { IsAcceptCall, MessageId } = payload;
    if (!IsAcceptCall) {
      let data = {
        clientChatRoomId: state.clientChatRoom.id,
        customerId: state.AC_CustomerData.id,
        token: getters.token,
        content: REFUSES,
        type: "Text", // (System, Text, Image)
      };
      // console.log("SendMessageToAgent", data);
      dispatch("sendMessageToAgent", data);
    } else {
      // 若同意，先 initRTCPeerConnection
      // console.log("步驟三：同意。initRTCPeerConnection");
      dispatch("webrtc/initRTCPeerConnection", null, { root: true });
    }
    if (MessageId) {
      commit("setAcceptVideoCall", {
        isAcceptCall: IsAcceptCall,
        id: MessageId,
      });
    }

    state.connection.invoke("answerCall", payload);
  },
  sendSignalToAgent({ state, getters }, payload) {
    let route = router.currentRoute;
    let roomId = route.params.id || route.query.clientChatRoomId;
    let data = {
      ClientChatRoomId: roomId,
      CustomerId: state.AC_CustomerData.id,
      Token: getters.token,
      Signal: payload,
    };
    state.connection.invoke("sendSignalToAgent", data);
  },
  hangup({ state, dispatch, getters }) {
    let route = router.currentRoute;
    let roomId = route.params.id || route.query.clientChatRoomId;
    let params = {
      ClientChatRoomId: roomId,
      CustomerId: state.AC_CustomerData.id,
      Token: getters.token,
    };
    state.connection.invoke("hangUpByCustomer", params);
    dispatch("webrtc/hangup", null, { root: true });
  },
};

const mutations = {
  tooglePreventLeave(state, payload) {
    state.isPreventLeave = payload;
  },
  setCustomer(state, payload) {
    // console.log("setCustomer", payload);
    state.AC_CustomerData = payload;
    // localStorage.setItem('AC_CustomerData', JSON.stringify(payload))
  },
  updateCustomerData(state, paylaod) {
    const {
      showSurveyByChatSentences,
      showSurveyByChatTime,
      isShowSurveyByUserTalk,
      isClientSendFileToAgent,
      isClientSendImageToAgent,
      isRemoveClientGpsExifInfo,
      clientFileUploadLimit,
      clientImageFileUploadLimit,
    } = paylaod;
    const configs = state.AC_CustomerData.configs;

    configs.BasicSetting_ShowSurveyByChatSentences = showSurveyByChatSentences;
    configs.BasicSetting_ShowSurveyByChatTime = showSurveyByChatTime;
    configs.BasicSetting_ShowSurveyByUserTalk = isShowSurveyByUserTalk;

    configs.BasicSetting_IsClientSendFileToAgent = isClientSendFileToAgent;
    configs.BasicSetting_IsClientSendImageToAgent = isClientSendImageToAgent;
    configs.BasicSetting_IsRemoveClientGpsExifInfo = isRemoveClientGpsExifInfo;
    configs.BasicSetting_ClientFileUploadLimit = clientFileUploadLimit.split(
      " MB"
    )[0];
    configs.BasicSetting_ClientImageFileUploadLimit = clientImageFileUploadLimit.split(
      " MB"
    )[0];
  },
  cleanConnection(state) {
    // console.log("(destroyed 最後程序 Clean local connection");
    state.connection = null;
    // state.clientChatRoom = null; // 先保留資料 匯出對話紀錄參數需要
    // state.AC_CustomerData = null; // 先保留資料 匯出對話紀錄參數需要
    state.isChatFinish = false;
    state.isCustomerLeave = false;
    state.isAcceptVideoCall = null;
    state.offlineMessages = [];
    state.isRemoteControl = false;
  },
  setConnecttion(state, payload) {
    let connection = new signalR.HubConnectionBuilder()
      .withUrl(state.hubUrl, {
        transport: signalR.HttpTransportType.LongPolling,
        accessTokenFactory: () => payload,
      })
      .withAutomaticReconnect([
        10000, // 10s
        10000, // 20s
        10000, // 30s
        10000, // 40s
        10000, // 50s
        10000, // 60s
        10000, // 70s
        10000, // 80s
        10000, // 90s
        10000, // 100s
        20000, // 120s
        20000, // 140s
        20000, // 160s
        20000, // 180s
        20000, // 200s
        20000, // 220s
        20000, // 240s
        20000, // 260s
        20000, // 280s
        20000, // 300s
        10000, // 310s
        // 以上為 connection 偵測到斷線後自動重新連線的間隔 (Reconneting)
        // 310s後會結束連接 (Disconnected)
        // 因前端需判斷斷線 310s 提示UI, 因此重新連線的機制需累計超過300s
        // 否則 Disconnected 狀態會比斷線 300s 提早出現
      ])
      .configureLogging(signalR.LogLevel.Debug)
      .build();
    localStorage.setItem("AC_Connection", JSON.stringify(connection));
    state.connection = connection;
  },
  setWattingStatus(state, payload) {
    state.wattingStatus = payload;
  },
  setClientChatRoom(state, payload) {
    state.clientChatRoom = payload;
  },
  setAgentIsTyping(state, payload) {
    state.isAgentTyping = payload;
  },
  setOfflineMessage(state, payload) {
    const findIndex = state.clientChatRoom.messages.findIndex(
      (msg) => msg.uuid == payload.uuid
    );

    if (findIndex == -1) {
      // 若找不到這筆，才加入緩存區
      let tempMessage = {
        isTemp: true,
        ...payload,
      };
      state.offlineMessages.push(tempMessage);
    }
  },
  removeOfflineMessage(state, payload) {
    let target = state.offlineMessages.findIndex((m) => m.uuid == payload);
    if (target !== -1) {
      state.offlineMessages.splice(target, 1);
    }
  },
  updateMessage(state, payload) {
    state.clientChatRoom.messages.push(payload);
  },
  updateAllMessage(state, payload) {
    state.clientChatRoom.messages = payload;
  },
  removeMessage(state, payload) {
    state.clientChatRoom.messages.forEach((m) => {
      if (m.id == payload.messageId) {
        m.isHidden = true;
        return;
      }
    });
  },
  toggleChatFinish(state, payload) {
    state.isChatFinish = payload;
  },
  toggleCustomerLeave(state, payload) {
    state.isCustomerLeave = payload;
  },
  toggleAgentState(state, payload) {
    state.agentState = payload;
  },
  setAcceptVideoCall(state, { isAcceptCall, id }) {
    state.clientChatRoom.messages.forEach((m) => {
      if (m.id == id) {
        m.content = isAcceptCall;
        return;
      }
    });
  },
  setRemoteControl(state, payload) {
    state.isRemoteControl = payload;
  },
  setReplyMessage(state, payload) {
    state.replyMessage = payload;
  },
};

const getters = {
  connection: (state) => {
    return state.connection;
  },
  connectStatus: (state) => {
    if (state.connection) {
      return state.connection.connectionState;
    } else {
      return null;
    }
  },
  agentStatus: (state) => {
    return state.agentState;
  },
  isAgentTyping: (state) => {
    return state.isAgentTyping;
  },
  customerData: (state) => {
    return state.AC_CustomerData;
  },
  customerId: (state) => {
    if (state.AC_CustomerData) {
      return state.AC_CustomerData.id;
    } else {
      return "";
    }
  },
  userName: (state) => {
    if (state.AC_CustomerData) {
      return state.AC_CustomerData.userName;
    } else {
      return "";
    }
  },
  token: (state) => {
    if (state.AC_CustomerData) {
      return state.AC_CustomerData.token;
    } else {
      return "";
    }
  },
  roomId: (state) => {
    if (state.clientChatRoom) {
      return state.clientChatRoom.id;
    } else {
      return "";
    }
  },
  waitCount: (state) => {
    if (state.wattingStatus) {
      return state.wattingStatus.waitCount;
    } else {
      return 0;
    }
  },
  waitTime: (state) => {
    if (state.wattingStatus) {
      return state.wattingStatus.createAt;
    } else {
      return "";
    }
  },
  waitRoom: (state) => {
    if (state.wattingStatus) {
      return state.wattingStatus.roomId;
    } else {
      return "";
    }
  },
  lastMessage: (state) => {
    if (state.clientChatRoom) {
      let filter = state.clientChatRoom.messages
        .filter((m) => {
          return !m.isHidden && m.type !== "VideoCall" && m.type !== "QRCode";
        })
        .slice(-1)[0];
      return filter;
    } else {
      return [];
    }
  },
  isClientTalk: (state) => {
    const room = state.clientChatRoom;
    if (room) {
      const messages = room.messages.filter(
        (msg) =>
          msg.user && msg.type !== "CustomerStatus" && msg.type !== "System"
      );
      const isTalk = messages.findIndex((msg) => msg.user.isCustomer);
      return isTalk == -1 ? false : true;
    } else {
      return false;
    }
  },
  surveyCondition1: (state, getters, rootState, rootGetters) => {
    const ShowSurveyByChatTime =
      state.AC_CustomerData.configs.BasicSetting_ShowSurveyByChatTime;
    let totalTime = rootState.global.totalTime;
    return totalTime >= ShowSurveyByChatTime;
  },
  surveyCondition2: (state, getters) => {
    const IsShowSurveyByUserTalk =
      state.AC_CustomerData.configs.BasicSetting_ShowSurveyByUserTalk;
    return IsShowSurveyByUserTalk ? getters.isClientTalk : true;
    // 若不判斷使用者是否傳送訊息
    // 條件2回傳true 只判斷條件1的時間就顯示問卷
  },
  surveyCondition3: (state) => {
    // isRemoteControl = true 回傳 false 不顯示問卷(專員結束對話,ART005)
    // isRemoteControl = false 回傳 true 可顯示問卷(正常情境,預設)
    return !state.isRemoteControl;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
